export default __webpack_public_path__ + "static/media/bgFeaturedRace.7c4b9a6e.png";